export const productsSchema = {
  title: 'Products schema',
  description: 'Describes products',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'number',
    },
    updatedAt: {
      type: 'number',
    },
    name: {
      type: 'string',
      minimum: 0,
    },
  },
  required: ['id', 'name'],
}
